import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

// Figma "Radiobutton" with a description (MAX-4419 Version cards, Display Theme).
export const styles = (theme: Theme) => {
	return ({
		option: {
			alignItems: "flex-start",
			marginLeft: 0,
			marginRight: 0,
			marginBottom: theme.spacing(3),
			"&:last-child": {
				marginBottom: 0,
			},
		},
		radio: {
			padding: 0,
			marginRight: theme.spacing(2),
			color: baseColors.gray200,
			"&.Mui-checked": {
				color: theme.palette.secondary.main,
			},
		},
		titleRow: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
		},
		title: {
			color: theme.palette.custom.textPrimary,
			fontSize: 16,
			fontWeight: 700,
			lineHeight: "24px",
		},
		description: {
			color: theme.palette.custom.textPrimary,
			fontSize: 16,
			lineHeight: "24px",
			marginTop: theme.spacing(1),
		},
		// Pulled up under its option, whose own bottom margin spaces it from the next one.
		after: {
			marginTop: theme.spacing(-1),
			marginBottom: theme.spacing(3),
			"&:last-child": {
				marginBottom: 0,
			},
		},
	} satisfies Record<string, CSSObject>);
};
